<template>

    <div>
        <div v-if="hasRole('System Administrator')">
            <h3 class="text-center">
                Reports
            </h3>
            <div class="flex justify-center">
                <div class="md:w-1/2 pt-5">
                    <a href="/reports/assignment-status" class="no-underline">
                        <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
                            <d-icon size="2x" icon="file-alt" />
                        </div>
                        <p class="text-center mt-3">Assignment Status Report</p>
                    </a>
                </div>
            </div>
        </div>
        <h3 class="text-center pt-5">
            Excel Exports
        </h3>
        <div class="flex flex-wrap">
            <div class="md:w-1/3 w-1/2 pt-5">
                <a href="/reports/todo-items" class="no-underline">
                    <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
                        <d-icon size="2x" icon="file-alt" />
                    </div>
                    <p class="text-center mt-3">Tasks</p>
                </a>
            </div>

            <div class="md:w-1/3 w-1/2 pt-5">
                <a href="/reports/assignments" class="no-underline">
                    <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
                        <d-icon size="2x" icon="file-alt" />
                    </div>
                    <p class="text-center mt-3">Assignments</p>
                </a>
            </div>

            <div class="md:w-1/3 w-1/2 pt-5" v-if="hasRole('System Administrator')">
                <a href="/reports/todo-submissions" class="no-underline">
                    <div class="bg-yellow-500 p-12 rounded-full h-16 w-16 flex mx-auto items-center justify-center text-white">
                        <d-icon size="2x" icon="file-alt" />
                    </div>
                    <p class="text-center mt-3">Task Submissions By Date Range</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        parent: true,

        computed: {
            ...mapGetters('d2Auth', ['profile', 'hasRole']),
        },
    };
</script>